import { render, staticRenderFns } from "./FbPageElement.vue?vue&type=template&id=6d689f34&scoped=true&"
import script from "./FbPageElement.vue?vue&type=script&lang=js&"
export * from "./FbPageElement.vue?vue&type=script&lang=js&"
import style0 from "./FbPageElement.vue?vue&type=style&index=0&id=6d689f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d689f34",
  null
  
)

export default component.exports